import moment from "moment";
import { powerPlayTeamsForCode } from "./Constants";
import { getHittingPoint } from "./DefaultAttackCombos.js";
import {
  addStatsItem,
  calculateAllStats,
  createStatsItem,
  doEvent,
} from "./StatsItem.js";
import {
  generateUUID,
  inside,
  pad,
  stringToPoint,
  tryParseDateFromString,
  unzipBuffer,
} from "./Utils";
import { myunzip } from "./zip.js";
const kSkillServe = 1;
const kSkillPass = 2;
const kSkillSet = 3;
const kSkillSpike = 4;
const kSkillBlock = 5;
const kSkillDefense = 6;
const kSkillFreeball = 7;
const kSkillCover = 7;
const kSkillCoachTag = 8;
const kSkillEndOfSet = 9;
const kSkillTransitionSO = 10;
const kSkillTransitionPoint = 11;
const kSkillPointWonServe = 12;
const kSkillPointLostServe = 13;
const kSkillPointWonReceive = 14;
const kSkillPointLostReceive = 15;
const kSkilliCodaAttack = 16;
const kSkilliCodaDefense = 17;
const kSkillCodeError = 18;
const kSkillOppositionError = 19;
const kSkillSettersCall = 20;
// Manual point (the "Point" buttons in DVMatchCoding, skill "P"). DataVolley
// has no "P" skill so this is a VBLive-only EventType, written by DVWWriter as
// a player-less `*00P~<eval>` code and mapped back to skill "P" in
// DVMatchCoding's SKILL_BY_EVENT_TYPE.
const kSkillManualPoint = 40;

const kOppositionScore = 100;
const kOppositionError = 101;
const kOppositionHitKill = 102;
const kOppositionHitError = 103;
const kOppositionServeError = 104;
const kOppositionServeAce = 105;
const kSkillCommentary = 200;
const kSkillTimeout = 201;
const kSkillTechTimeout = 202;
const kSubstitution = 250;
const kSkillOppositionServe = 401;
const kSkillOppositionSpike = 404;

const kServeH = 1;
const kServeM = 2;
const kServeQ = 3;
const kServeO = 4;

const kPassH = 1;
const kPassM = 2;
const kPassQ = 3;
const kPassO = 4;

const kSpikeH = 1;
const kSpikeM = 2;
const kSpikeQ = 3;
const kSpikeT = 4;
const kSpikeU = 5;
const kSpikeF = 6;
const kSpikeO = 7;

var currentGame = null;
var isSideOut = false;

export function initWithDVWCompressedBuffer(buf) {
  var buffer = unzipBuffer(buf);
  if (!buffer) {
    buffer = myunzip(buf);
  }
  // console.log(buffer)
  if (!buffer) {
    // toast.error("Invalid DataVolley data.");
    return;
  } else {
    return generateMatch(buffer);
  }
}

var index = 1;
var rows = [0, 1, 6, 5, 4, 3, 2];
var ets = ["S", "R", "E", "A", "B", "D", "F"];
var egs = ["=", "-", "/", "!", "+", "", "#"];

var homelineup = [];
var awaylineup = [];

var attackCombo = "";

var isPractice = false;
var homelibs = [];
var awaylibs = [];
var match = null;
var matchdate = null;
// [3MATCH]'s date field is usually "MM/DD/YYYY", but some real exports use
// "YYYY/MM/DD" (year-first) instead — detected once per parse from the actual
// token lengths and reused for every per-event moment() parse below, instead
// of assuming MM/DD/YYYY unconditionally (which silently produced an Invalid
// Date, and therefore NaN timestamps/video positions, for year-first files).
var matchDateFormat = "MM/DD/YYYY";
var homeTeam = null;
var awayTeam = null;
var homeSetter = 0;
var awaySetter = 0;
var homerow = 0;
var awayrow = 0;
var homescore = 0;
var awayscore = 0;
var subevent = 0;
var currentGame = 1;
var sc = "";
var passEvent = "";
var homeServing = true;
var scores = "0-0";
var genday;
var ssecs = [
  "[3MATCH]",
  "[3TEAMS]",
  "[3MORE]",
  "[3SET]",
  "[3PLAYERS-H]",
  "[3PLAYERS-V]",
  "[3ATTACKCOMBINATION]",
  "[3SETTERCALL]",
  "[3SCOUT]",
  "[3VIDEO]",
  "[3COMMENTS]",
];

// `options.winScore` (number) and `options.winByTwo` (boolean) let the
// caller override the standard FIVB rules (25 points per set, 15 for the
// deciding set, win by 2) used to compute `match.HomeScore`/`match.AwayScore`
// (sets won) from each set's final score read out of the DVW file. Left
// undefined, behaviour is unchanged (standard rules).

// Lightweight standalone scan of a DVW/DataVolley text buffer's `[3SET]`
// section for each set's final score — used to auto-detect a non-standard
// "points to close a set" rule (e.g. a custom-capped league) BEFORE a full
// generateMatch() parse, since that parse itself needs the winScore option
// up front to compute match.HomeScore/AwayScore correctly. Mirrors the same
// sm[4] "HS-AS" field generateMatch's own [3SET] case reads.
export function extractSetScoresFromDVWText(text) {
  if (typeof text !== "string") return [];
  const lines = text.split(/\r?\n/);
  const start = lines.indexOf("[3SET]");
  if (start === -1) return [];
  const scores = [];
  for (let i = start + 1; i < lines.length; i++) {
    const line = lines[i];
    if (line.startsWith("[3")) break;
    const sm = line.split(";");
    if (sm.length < 7) continue;
    const setScore = sm[4];
    if (!setScore) continue;
    const scs = setScore.split("-");
    if (scs.length !== 2) continue;
    const home = parseInt(scs[0], 10);
    const away = parseInt(scs[1], 10);
    if (Number.isFinite(home) && Number.isFinite(away)) {
      scores.push({ home, away });
    }
  }
  return scores;
}

export function generateMatch(str, options) {
  index = 1;

  homelineup = [];
  awaylineup = [];

  attackCombo = "";

  isPractice = false;
  homelibs = [];
  awaylibs = [];
  match = null;
  matchdate = null;
  matchDateFormat = "MM/DD/YYYY";
  homeTeam = null;
  awayTeam = null;
  homeSetter = 0;
  awaySetter = 0;
  homerow = 0;
  awayrow = 0;
  homescore = 0;
  awayscore = 0;
  subevent = 0;
  currentGame = 1;
  sc = "";
  passEvent = "";
  homeServing = true;
  scores = "0-0";

  var lastvp = -1;
  var keyvp = 0;
  homerow = 0;
  awayrow = 0;
  homescore = 0;
  awayscore = 0;
  homeTeam = null;
  awayTeam = null;
  dateAtVideoPositionZero = null;
  index = 1; // Reset per parse so EventIds are deterministic across re-parses.

  // Strip any leading platform metadata (e.g. macOS resource-fork bytes) that
  // may be prepended to the DVW content before the actual file header.
  var dvwStart = str.indexOf("[3DATAVOLLEYSCOUT]");
  if (dvwStart === -1) {
    return null;
  }
  var a = str.substring(dvwStart).split(/\r?\n/);

  var linecount = a.length;

  var section;
  var gamenumber = 1;
  for (var nl = 1; nl < a.length; nl++) {
    var s = a[nl];
    subevent = 0;
    if (s.includes("GENERATOR-DAY")) {
      genday = s;
    }
    if (ssecs.filter((ss) => ss === s).length > 0) {
      section = ssecs.findIndex((ss) => ss === s);
    }
    // if (section === -1)
    // {
    //     continue
    // }
    switch (section) {
      case 0: //match
        {
          var sm = s.split(";");
          if (sm.length >= 13) {
            matchdate = sm[0];
            var matchtime = sm[1];
            if (matchtime.length == 0) {
              matchtime = "00:00:00";
            }
            // A 4-digit first token (e.g. "2026/10/09") means the date is
            // year-first; otherwise keep the default MM/DD/YYYY assumption.
            const dateTokens = matchdate.split("/");
            matchDateFormat =
              dateTokens[0] && dateTokens[0].length === 4
                ? "YYYY/MM/DD"
                : "MM/DD/YYYY";
            match = {};
            match.events = [];
            match.players = [];
            match.oppositionPlayers = [];
            match.drills = [];
            match.attackCombos = [];
            match.setterCalls = [];
            match.HomeScore = 0;
            match.AwayScore = 0;
            const datestr = matchdate + " " + matchtime.replace(/\./g, ":");
            match.TrainingDate = tryParseDateFromString(datestr, "mdy");
            if (match.TrainingDate === undefined) {
              match.TrainingDate = tryParseDateFromString(datestr, "ymd");
              if (match.TrainingDate === undefined) {
                let tk1s = matchdate.split("/");
                let day, month, year;
                if (matchDateFormat === "YYYY/MM/DD") {
                  year = Number.parseInt(tk1s[0]);
                  month = Number.parseInt(tk1s[1]);
                  day = Number.parseInt(tk1s[2]);
                } else {
                  day = Number.parseInt(tk1s[0]);
                  month = Number.parseInt(tk1s[1]);
                  if (month > 12) {
                    const temp = day;
                    day = month;
                    month = temp;
                  }
                  year = Number.parseInt(tk1s[2]);
                }
                let hour = 0;
                let minute = 0;
                let second = 0;
                let tk2s = matchtime.split(".");
                if (tk2s.length == 1) {
                  tk2s = matchtime.split(":");
                }
                if (tk2s.length >= 3) {
                  hour = Number.parseInt(tk2s[0]);
                  minute = Number.parseInt(tk2s[1]);
                  second = Number.parseInt(tk2s[2]);
                }
                const dd = new Date(year, month - 1, day, hour, minute, second);
                match.TrainingDate = dd;
              }
            }
            match.tournamentName = sm[3];
            match.dvstring = s;
            // Round-trip metadata written by DVWWriter: sm[4]=guid, sm[5]=homeLiberos, sm[6]=awayLiberos.
            // Only accept sm[4] as a GUID if it is a valid UUID — DataVolley itself may put a
            // libero jersey number or match serial in that field, which must not be used as an ID.
            const maybeGuid = sm[4] ? sm[4].trim() : "";
            if (
              /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
                maybeGuid,
              )
            ) {
              match.guid = maybeGuid;
            }
            // matchdate is captured here for deterministic GUID fallback below.
            const parseLiberoField = (f) => {
              if (!f || !f.trim()) return null;
              const nums = f
                .split(",")
                .map((v) => parseInt(v.trim(), 10))
                .filter((n) => Number.isFinite(n) && n > 0);
              return nums.length > 0 ? nums : null;
            };
            match.liberoA = parseLiberoField(sm[5]);
            match.liberoB = parseLiberoField(sm[6]);
          }
        }
        break;
      case 1: //teams
        {
          var sm = s.split(";");
          if (sm.length >= 7) {
            var desc = sm[1];
            var descx = unzipBuffer(desc);
            var name = descx === null ? desc : descx;
            // Team colour round-trip: DVWWriter stores a "#rrggbb" hex value in
            // a spare [3TEAMS] field. Accept it ONLY when it looks like hex so a
            // real imported DataVolley file (coach names etc.) is never misread.
            var teamColour = null;
            for (var cf = 0; cf < sm.length; cf++) {
              var cval = (sm[cf] ?? "").trim();
              if (/^#[0-9a-f]{6}$/i.test(cval)) {
                teamColour = cval.toLowerCase();
                break;
              }
            }
            if (homeTeam === null) {
              homeTeam = {};
              homeTeam.Name = name;
              homeTeam.Code = sm[0];
              if (teamColour) homeTeam.colour = teamColour;
              match.Team = homeTeam;
              match.teamA = homeTeam;
              match.teamA.players = [];
            } else {
              awayTeam = {};
              awayTeam.Name = name;
              awayTeam.Code = sm[0];
              if (teamColour) awayTeam.colour = teamColour;
              match.Opposition = awayTeam;
              match.teamB = awayTeam;
              match.teamB.players = [];
            }
          }
        }
        break;
      case 2: //more
        {
          var sm = s.split(";");
          if (sm.length >= 7) {
            match.venue = sm[3];
          } else if (sm.length >= 2) {
            homeSetter = parseInt(sm[1]);
            awaySetter = parseInt(sm[2]);
            // Persist the primary setter shirt numbers on the match so
            // callers (e.g. DVMatchCoding resuming a saved match) don't have
            // to re-prompt the user to nominate a setter for each team.
            match.setterA =
              Number.isFinite(homeSetter) && homeSetter > 0 ? homeSetter : null;
            match.setterB =
              Number.isFinite(awaySetter) && awaySetter > 0 ? awaySetter : null;
          }
        }
        break;
      case 3: //sets
        {
          var sm = s.split(";");
          if (sm.length >= 7) {
            var setScore = sm[4];
            if (setScore.length !== 0) {
              var token1 = sm[1];
              var d = {};
              d.match = match;
              d.events = [];
              d.players = [];
              d.oppositionPlayers = [];
              for (var np = 0; np < match.players.length; np++) {
                var pl = match.players[np];
                d.players.push(pl);
              }
              for (var np = 0; np < match.oppositionPlayers.length; np++) {
                var pl = match.oppositionPlayers[np];
                d.oppositionPlayers.push(pl);
              }
              d.GameNumber = gamenumber;
              if (
                match.drills.filter((obj) => obj.GameNumber === gamenumber)
                  .length === 0
              ) {
                match.drills.push(d);
              }
              d.trainingSession = match;
              d.drillDuration = duration;

              var setScore = sm[4];
              var duration = parseInt(sm[5]);
              if (setScore.length > 0) {
                var scs = setScore.split("-");
                var xhomescore = parseInt(scs[0]);
                var xawayscore = parseInt(scs[1]);
                d.HomeScore = xhomescore;
                d.AwayScore = xawayscore;
                var mhs = parseInt(match.HomeScore);
                var mas = parseInt(match.AwayScore);
                var winningscore =
                  options?.winScore != null
                    ? options.winScore
                    : gamenumber > 4
                    ? 15
                    : 25;
                var requireWinByTwo = options?.winByTwo !== false;
                var margin = requireWinByTwo ? 1 : 0;
                if (xhomescore >= winningscore || xawayscore >= winningscore) {
                  if (xhomescore > xawayscore + margin) {
                    mhs++;
                  } else if (xawayscore > xhomescore + margin) {
                    mas++;
                  }
                }
                match.HomeScore = mhs;
                match.AwayScore = mas;
              }
            }
            gamenumber++;
          }
        }
        break;
      case 4: // home players
        {
          var sm = s.split(";");
          if (sm.length >= 7) {
            var pl = createPlayer(s);
            if (pl != null) {
              match.players.push(pl);
              match.teamA.players.push(pl);
              pl.shirtNumber = parseInt(sm[1]);

              var spos = sm.length > 13 ? sm[13] : "";
              if (spos.length > 0) {
                var posname = [
                  "",
                  "Libero",
                  "Pass/Hitter",
                  "Opposite",
                  "Middle",
                  "Setter",
                ];
                var npos = parseInt(spos);
                if (pl.Positions.filter((obj) => obj === npos).length === 0) {
                  pl.Positions.push(npos);
                }
                if (npos == 1) {
                  if (homelibs.filter((obj) => obj === pl).length === 0) {
                    homelibs.push(pl);
                  }
                }
              }
              if (
                match.players.filter((obj) => obj.Guid === pl.Guid).length === 0
              ) {
                match.players.push(pl);
              }
              for (var nd = 0; nd < match.drills.length; nd++) {
                var d = match.drills[nd];
                if (
                  d.players.filter((obj) => obj.Guid === pl.Guid).length === 0
                ) {
                  d.players.push(pl);
                }
              }
            }
          }
        }
        break;
      case 5: // away players
        {
          var sm = s.split(";");
          if (sm.length >= 7) {
            var pl = createPlayer(s);
            if (pl != null) {
              match.oppositionPlayers.push(pl);
              match.teamB.players.push(pl);
              pl.shirtNumber = parseInt(sm[1]);

              var spos = sm.length > 13 ? sm[13] : "";
              if (spos.length > 0) {
                var posname = [
                  "",
                  "Libero",
                  "Pass/Hitter",
                  "Opposite",
                  "Middle",
                  "Setter",
                ];
                var npos = parseInt(spos);
                if (pl.Positions.filter((obj) => obj === npos).length === 0) {
                  pl.Positions.push(npos);
                }
                if (npos == 1) {
                  if (awaylibs.filter((obj) => obj === pl).length === 0) {
                    awaylibs.push(pl);
                  }
                }
              }
              if (
                match.oppositionPlayers.filter((obj) => obj.Guid === pl.Guid)
                  .length === 0
              ) {
                match.oppositionPlayers.push(pl);
              }
              for (var nd = 0; nd < match.drills.length; nd++) {
                var d = match.drills[nd];
                if (
                  d.oppositionPlayers.filter((obj) => obj.Guid === pl.Guid)
                    .length === 0
                ) {
                  d.oppositionPlayers.push(pl);
                }
              }
            }
          }
        }
        break;
      case 6: //attack combinations
        {
          var sm = s.split(";");
          if (sm.length >= 11) {
            var ac = getAttackCombination(s);
            if (
              ac !== null &&
              match.attackCombos.filter((obj) => obj.code === ac.code)
                .length === 0
            ) {
              match.attackCombos.push(ac);
            }
            if (attackCombo.length > 0) {
              attackCombo += "|";
            }
            attackCombo += s;
          }
        }
        break;
      case 7: //setter calls
        {
          var sm = s.split(";");
          if (sm.length > 8) {
            var sc = getSettersCall(s);
            if (
              sc !== null &&
              match.setterCalls.filter((obj) => obj.code === sc.code).length ===
                0
            ) {
              match.setterCalls.push(sc);
            }
          }
        }
        break;
      case 8: //scout
        {
          processScoutLine(s);
        }
        break;
      case 9: // video
      case 10: // comment
        {
          if (s.startsWith("http") === true) {
            match.videoUrl = s;
          } else if (s.startsWith(";http") === true) {
            match.videoUrl = s.substring(1);
          } else if (s.startsWith(";offset=") === true) {
            match.videoOffset = Number.parseInt(s.substring(8));
          }
        }
        break;
    }
  }

  match.UserDefined2 = attackCombo;

  // convert to cones
  var evs = match.events;
  for (var ne = 0; ne < evs.length; ne++) {
    var e = evs[ne];
    if (e.EventType !== kSkillSpike) {
      continue;
    }

    var coneno = e.endZone;
    if (match.isZone) {
      var endPoint = stringToPoint(e.BallEndString);
      if (endPoint === null) {
        continue;
      }
      endPoint = { x: 100 - endPoint.x, y: 100 - endPoint.y };

      var ac = fetchAttackComboByCode(e.attackCombo);
      if (ac !== null) {
        // const canvas = document.getElementById("canvas");
        // const ctx = canvas.getContext("2d");

        var startzone = e.startZone;
        if (realTargetHitter(ac) === "F") {
          var cones = [
            { x: 100, y: 0 },
            { x: 100, y: 100 },
            { x: 88, y: 100 },
            { x: 87, y: 0 },
            { x: 88, y: 0 },
            { x: 88, y: 0 },
            { x: 88, y: 100 },
            { x: 70, y: 100 },
            { x: 87, y: 0 },
            { x: 88, y: 0 },
            { x: 88, y: 0 },
            { x: 70, y: 100 },
            { x: 56, y: 100 },
            { x: 87, y: 0 },
            { x: 88, y: 0 },
            { x: 88, y: 0 },
            { x: 56, y: 100 },
            { x: 22, y: 100 },
            { x: 87, y: 0 },
            { x: 88, y: 0 },
            { x: 88, y: 0 },
            { x: 22, y: 100 },
            { x: 0, y: 100 },
            { x: 0, y: 70 },
            { x: 88, y: 0 },
            { x: 88, y: 0 },
            { x: 0, y: 70 },
            { x: 0, y: 40 },
            { x: 87, y: 0 },
            { x: 88, y: 0 },
            { x: 88, y: 0 },
            { x: 0, y: 40 },
            { x: 0, y: 0 },
            { x: 87, y: 0 },
            { x: 88, y: 0 },
          ];
          for (var nn = 0; nn < 7; nn++) {
            // ctx.beginPath()
            // ctx.moveTo(cones[nn * 5 + 0].x, cones[nn * 5 + 0].y)
            var polygon = [];
            var pt = [];
            pt.push(cones[nn * 5 + 0].x);
            pt.push(cones[nn * 5 + 0].y);
            polygon.push(pt);
            for (var mm = 1; mm < 5; mm++) {
              // ctx.lineTo(cones[nn * 5 + mm].x, cones[nn * 5 + mm].y)
              var pt = [];
              pt.push(cones[nn * 5 + mm].x);
              pt.push(cones[nn * 5 + mm].y);
              polygon.push(pt);
            }
            // if (ctx.isPointInPath(endPoint.x, endPoint.y))
            if (inside([endPoint.x, endPoint.y], polygon)) {
              coneno = nn + 1;
              break;
            }
          }
        } else if (realTargetHitter(ac) === "B") {
          var cones = [
            { x: 0, y: 0 },
            { x: 0, y: 100 },
            { x: 12, y: 100 },
            { x: 11, y: 0 },
            { x: 12, y: 0 },
            { x: 12, y: 0 },
            { x: 28, y: 100 },
            { x: 12, y: 100 },
            { x: 11, y: 0 },
            { x: 12, y: 0 },
            { x: 12, y: 0 },
            { x: 44, y: 100 },
            { x: 28, y: 100 },
            { x: 11, y: 0 },
            { x: 12, y: 0 },
            { x: 12, y: 0 },
            { x: 80, y: 100 },
            { x: 44, y: 100 },
            { x: 11, y: 0 },
            { x: 12, y: 0 },
            { x: 12, y: 0 },
            { x: 100, y: 80 },
            { x: 100, y: 100 },
            { x: 80, y: 100 },
            { x: 12, y: 0 },
            { x: 12, y: 0 },
            { x: 100, y: 44 },
            { x: 100, y: 80 },
            { x: 11, y: 0 },
            { x: 12, y: 0 },
            { x: 12, y: 0 },
            { x: 100, y: 0 },
            { x: 100, y: 44 },
            { x: 11, y: 0 },
            { x: 12, y: 0 },
          ];

          for (var nn = 0; nn < 7; nn++) {
            var polygon = [];
            var pt = [];
            pt.push(cones[nn * 5 + 0].x);
            pt.push(cones[nn * 5 + 0].y);
            polygon.push(pt);
            for (var mm = 1; mm < 5; mm++) {
              var pt = [];
              pt.push(cones[nn * 5 + mm].x);
              pt.push(cones[nn * 5 + mm].y);
              polygon.push(pt);
            }
            if (inside([endPoint.x, endPoint.y], polygon)) {
              coneno = nn + 1;
              break;
            }
          }
          if (startzone == 2) {
            // DLog("startzone=%d cone=%d %@-%@ %", startzone, coneno, e.BallStartString, e.BallEndString, e.dvString);
          }
        } //if (ac.realTargetHitter isEqualToString:"Q"])
        else {
          var cones = [
            { x: 50, y: 0 },
            { x: 100, y: 0 },
            { x: 100, y: 54 },
            { x: 60, y: 54 },
            { x: 100, y: 54 },
            { x: 100, y: 100 },
            { x: 80, y: 100 },
            { x: 80, y: 54 },
            { x: 80, y: 54 },
            { x: 80, y: 100 },
            { x: 60, y: 100 },
            { x: 60, y: 54 },
            { x: 60, y: 54 },
            { x: 60, y: 100 },
            { x: 40, y: 100 },
            { x: 40, y: 54 },
            { x: 40, y: 54 },
            { x: 40, y: 100 },
            { x: 20, y: 100 },
            { x: 20, y: 54 },
            { x: 20, y: 54 },
            { x: 20, y: 100 },
            { x: 0, y: 100 },
            { x: 0, y: 54 },
            { x: 50, y: 0 },
            { x: 40, y: 54 },
            { x: 0, y: 54 },
            { x: 0, y: 0 },
            { x: 50, y: 0 },
            { x: 60, y: 54 },
            { x: 40, y: 54 },
            { x: 50, y: 0 },
          ];
          for (var nn = 0; nn < 8; nn++) {
            var polygon = [];
            var pt = [];
            pt.push(cones[nn * 4 + 0].x);
            pt.push(cones[nn * 4 + 0].y);
            polygon.push(pt);
            for (var mm = 1; mm < 4; mm++) {
              var pt = [];
              pt.push(cones[nn * 4 + mm].x);
              pt.push(cones[nn * 4 + mm].y);
              polygon.push(pt);
            }
            if (inside([endPoint.x, endPoint.y], polygon)) {
              coneno = nn + 1;
              break;
            }
          }
        }
      }
    }
    e.coneNumber = coneno;
  }

  match.sets = match.drills;
  var dd = matchdate.split("/");
  match.code =
    dd[0] +
    "." +
    dd[1] +
    "." +
    dd[2] +
    "~" +
    match.teamA.Code +
    "vs" +
    match.teamB.Code;

  // If the file had no embedded UUID, derive a stable deterministic GUID from
  // the match code so that re-importing the same file (e.g. for live updates)
  // overwrites the same Firestore document rather than creating a duplicate.
  // IMPORTANT: match.code alone (date + team codes) is NOT enough to identify
  // a specific match -- two genuinely different matches between the same two
  // teams on the same day (a common pool-play/round-robin/rematch scenario)
  // produce the IDENTICAL guid and silently overwrite each other's Firestore
  // document (reported as matches "disappearing" after importing/sharing
  // another match with the same/similar team names). The match's own start
  // TIME-OF-DAY (matchtime, e.g. "09.39.53") is included too -- two separate
  // matches can't realistically start at the exact same second, while a
  // live match re-exported progressively (more events each time) always
  // keeps the same start time, so the intended re-import dedup still works.
  if (!match.guid && match.code) {
    match.guid = deterministicUUIDFromString(match.code + "~" + (matchtime || ""));
  }

  // stringify attackCombos without trainingSession element
  // console.log(
  //   JSON.stringify(
  //     match.attackCombos,
  //     (key, value) => (key === "trainingSession" ? undefined : value),
  //     2,
  //   ),
  // );
  //write attackCombos to a JSON file for debugging
  // const fs = require('fs');
  // fs.writeFileSync('attackCombos.json', JSON.stringify(match.attackCombos, null, 2));
  // console.log("match = ", match);
  return match;
}

// Derives a stable UUID-format string from an arbitrary input string using a
// simple double-FNV-1a hash.  Not cryptographic, but collision-resistant enough
// for match identification (date + team codes).
function deterministicUUIDFromString(str) {
  var h1 = 0x811c9dc5;
  var h2 = 0x811c9dc5 ^ (str.length * 0x01000193);
  for (var i = 0; i < str.length; i++) {
    var c = str.charCodeAt(i);
    h1 ^= c;
    h1 = Math.imul(h1, 0x01000193);
    h2 ^= str.charCodeAt(str.length - 1 - i);
    h2 = Math.imul(h2, 0x01000193);
  }
  h1 = h1 >>> 0;
  h2 = h2 >>> 0;
  var h3 = Math.imul(h1 ^ (h2 >>> 16), 0x45d9f3b) >>> 0;
  var h4 = Math.imul(h2 ^ (h1 >>> 16), 0x45d9f3b) >>> 0;
  var toHex = function (n, len) {
    return (n >>> 0).toString(16).padStart(len, "0");
  };
  // Version 4 variant bits for UUID-format compatibility (accepted by safeId).
  return (
    toHex(h1, 8) +
    "-" +
    toHex(h2 & 0xffff, 4) +
    "-" +
    "4" +
    toHex((h3 >> 4) & 0xfff, 3) +
    "-" +
    toHex(8 | ((h4 >> 30) & 0x3), 1) +
    toHex(h4 & 0xfff, 3) +
    "-" +
    toHex(h1 ^ h3, 8) +
    toHex(h2 ^ h4, 4)
  );
}

// A name field that is empty or made up entirely of "?" / replacement
// characters means the player's name could not be encoded into the file's text
// encoding and is therefore unusable for display.
function isGarbledName(s) {
  return s == null || /^[?\uFFFD\s]*$/.test(s);
}

// Some DataVolley exports write non-Latin player names as literal "?" in the
// plain-text name fields, but also store the name hex-encoded in a later field
// (which is encoding independent). The first character is the number of hex
// digits per character (2 = single byte / Latin, 4 = UTF-16 code unit), the
// rest is the hex data. Returns the decoded name, or null if not decodable.
function decodeDVWName(field) {
  if (!field) {
    return null;
  }
  var width = field.charCodeAt(0) - 48; // leading digit: hex digits per char
  if (width !== 2 && width !== 4) {
    return null;
  }
  var body = field.slice(1);
  if (
    body.length === 0 ||
    body.length % width !== 0 ||
    !/^[0-9a-fA-F]+$/.test(body)
  ) {
    return null;
  }
  var out = "";
  for (var i = 0; i < body.length; i += width) {
    out += String.fromCharCode(parseInt(body.substr(i, width), 16));
  }
  return out;
}

function createPlayer(s) {
  var pl = null;
  var sm = s.split(";");
  // Need at least indices 0-11 for shirt number (sm[1]) + the three name fields
  // (sm[9] last, sm[10] first, sm[11] nick). Some older/shorter DVW exports have
  // fewer than 16 fields; they were previously silently dropped.
  if (sm.length >= 12) {
    if (sm[10] === "Player") {
      return null;
    }
    //dealing with unicode
    var desc = sm[9];
    var descx = unzipBuffer(desc);
    var lastname = descx == null ? desc : descx;
    desc = sm[10];
    descx = unzipBuffer(desc);
    var firstname = descx == null ? desc : descx;
    desc = sm[11];
    descx = unzipBuffer(desc);
    var nickname = descx == null ? desc : descx;

    // Recover names that were stored as "???" in the text fields from the
    // hex-encoded native (sm[19]) / romanized (sm[17]) name fields.
    // These optional fields only exist in longer-format exports.
    var encNative = sm.length > 19 ? decodeDVWName(sm[19]) : null;
    var encRoman = sm.length > 17 ? decodeDVWName(sm[17]) : null;
    if (isGarbledName(lastname)) {
      lastname = encRoman || encNative || lastname;
    }
    if (isGarbledName(nickname)) {
      nickname = encNative || encRoman || "";
    }

    pl = {};
    pl.FirstName = firstname;
    pl.LastName = lastname;
    pl.NickName = nickname === "" ? lastname : nickname;
    pl.Guid = generateUUID();
    pl.Positions = [];
    pl.Role = sm[12];
  }
  return pl;
}

function getAttackCombination(s) {
  var sm = s.split(";");
  var code = sm[0];

  var desc = sm[4];
  var descx = unzipBuffer(desc);
  var acname = descx == null ? desc : descx;

  var ac = {};
  ac.trainingSession = match;
  ac.code = code;
  ac.approach = sm[2];
  ac.ballType = sm[3];
  ac.name = acname;
  ac.startZone = sm[1];
  ac.coords = sm[7];
  ac.targetHitter = sm[8];
  ac.isBackcourt = parseInt(sm[9]);
  if (sm[7] && sm[7].length === 4) {
    var x = parseInt(sm[7]) % 100;
    var y = (parseInt(sm[7]) - x) / 100;
    ac.hittingPoint = { x: x, y: y };
  } else {
    ac.hittingPoint = getHittingPoint(code);
  }
  return ac;
}

function getSettersCall(s) {
  var sm = s.split(";");
  var code = sm[0];

  var desc = sm[2];
  var descx = unzipBuffer(desc);
  var name = descx == null ? desc : descx;

  var sc = {};
  sc.trainingSession = match;
  sc.code = code;
  sc.name = name;

  var ss = "";
  for (var n = 5; n < 9; n++) {
    var sn = sm[n];
    if (sn.length > 0) {
      if (ss.length > 0) {
        ss += "|";
      }
      ss += sn;
    }
  }

  sc.coords = ss;
  return sc;
}

function fetchAttackComboByCode(code) {
  var acs = match.attackCombos.filter((obj) => obj.code == code);
  if (acs.length === 1) {
    return acs[0];
  }
  return null;
}

function fetchPlayerInMatch(players, shirtNumber) {
  var pls = players.filter((obj) => obj.shirtNumber == shirtNumber);
  if (pls.length === 1) {
    return pls[0];
  }
  return null;
}

var lastTime = 0;
var lastvp = 0;
var keyvp = 0;
var dateAtVideoPositionZero = null;
var videoposoffset = 0;

// function processScoutLine(s) {
//     var shouldUpdate = false
//     var sm = s.split(";");
//     if (sm.length < 9) {
//         return shouldUpdate;
//     }
//     var coneno = 0;
//     var thisgame = currentGame;
//     if (isPractice == false) {
//         var stg = sm[8];
//         if (stg.length > 0) {
//             thisgame = parseInt(stg)
//         }
//     }
//     var g = match.drills[thisgame - 1]
//     if (g === undefined || g === null) {
//         return false;
//     }

//     currentGame = thisgame;
//     var code = sm[0];
//     var isHome = code.substring(0, 1) === "*"
//     var tm = isHome ? match.Team : match.Opposition;
//     var currentHomeLineup = [];
//     var currentAwayLineup = [];
//     var currentRotation = "";
//     var pos = 1;
//     homelineup = [];
//     currentHomeLineup = [];
//     awaylineup = [];
//     currentAwayLineup = [];
//     var cc1 = code.substring(0, 2)
//     var cc2 = code.substring(4, 8)
//     if (code.length == 8 && cc1 === "*P" && cc2 === ">LUp") {
//         for (var nr = 0; nr < 6; nr++) {
//             var nh = parseInt(sm[(14 + nr)]);

//             var pl = fetchPlayerInMatch(match.players, nh);
//             if (pl != null) {
//                 currentHomeLineup.push(pl);
//                 if (homelineup.filter(obj => obj.Guid === pl.Guid).length === 0) {
//                     homelineup.push(pl);
//                 }
//             }

//             var ah = parseInt(sm[(20 + nr)]);
//             pl = fetchPlayerInMatch(match.oppositionPlayers, ah);
//             if (pl != null) {
//                 currentAwayLineup.push(pl);
//                 if (awaylineup.filter(obj => obj.Guid === pl.Guid).length === 0) {
//                     awaylineup.push(pl);
//                 }
//             }
//         }

//         for (var np = 0; np < homelibs.length; np++) {
//             var pl = homelibs[np]
//             if (homelineup.filter(obj => obj.Guid === pl.Guid).length === 0) {
//                 homelineup.push(pl);
//             }
//         }
//         currentRotation = "";
//         pos = 1;
//         for (var np = 0; np < homelineup.length; np++) {
//             var pl = homelineup[np]
//             if (currentRotation.length > 0) {
//                 currentRotation += ",";
//             }
//             currentRotation += pl.Guid;
//             pos++;
//         }
//         g.StartingLineup = currentRotation;

//         for (var np = 0; np < awaylibs.length; np++) {
//             var pl = awaylibs[np]
//             if (awaylineup.filter(obj => obj.Guid === pl.Guid).length === 0) {
//                 awaylineup.push(pl);
//             }
//         }
//         var currentOppRotation = "";
//         pos = 1;
//         for (var np = 0; np < awaylineup.length; np++) {
//             var pl = awaylineup[np]
//             if (currentOppRotation.length > 0) {
//                 currentOppRotation += ",";
//             }
//             currentOppRotation += pl.Guid;
//             pos++;
//         }
//         g.OppositionStartingLineup = currentOppRotation;
//     }

//     if (code.length < 3) {
//         return shouldUpdate;
//     }

//     var eventCreated = false;
//     var vp = 0;
//     var tt = sm[7];
//     var sn = parseInt(code.substring(1, 3));
//     if (code.length >= 6 /* && tt != nil && tt.length > 0 */) {
//         var pls = isHome ? match.players : match.oppositionPlayers
//         var pl = fetchPlayerInMatch(pls, sn);
//         var net = 0;
//         var neg = 0;
//         var et = code.substring(3, 4);
//         var se = code.substring(4, 5);
//         var eg = code.substring(5, 6);
//         var homePlayer = isHome;
//         if (et === "S") {
//             if (homePlayer) {
//                 homeServing = true;
//             }
//             else {
//                 homeServing = false;
//             }
//         }
//         else if (et === "R") {
//             if (homePlayer) {
//                 homeServing = false;
//             }
//             else {
//                 homeServing = true;
//             }
//         }
//         if (tt.length == 0) {
//             tt = lastTime;
//         }
//         else {
//             lastTime = tt;
//         }

//         vp = 0;
//         if (sm.length > 12) {
//             var xnet = ets.indexOf(et)
//             if (xnet != -1) {
//                 var svp = sm[12];
//                 if (svp.length > 0) {
//                     vp = parseInt(svp)
//                     // for occasions when match was coded from segmented videos
//                     if (vp < lastvp && ((lastvp - (vp + keyvp)) > 1000)) {
//                         keyvp = lastvp;
//                     }
//                     vp += keyvp;
//                     lastvp = vp;
//                 }
//             }
//         }
//         var ts2 = null;
//         if (tt.length > 0) {
//             var ttt = matchdate + " " + tt.replace('.', ':')
//             ts2 = tryParseDateFromString(ttt, "mdy")
//             if (ts2 === undefined) {
//                 ts2 = tryParseDateFromString(ttt, "ymd")
//             }
//             if (ts2 === undefined) {
//                 ts2 = tryParseDateFromString(ttt, "dmy")
//             }
//             if (dateAtVideoPositionZero === null || dateAtVideoPositionZero === undefined) {
//                 dateAtVideoPositionZero = ts2;
//             }
//         }
//         if (vp != 0) {
//             if (videoposoffset === 0) {
//                 videoposoffset = vp;
//                 dateAtVideoPositionZero = new Date(ts2.getTime() - vp * 1000);
//             }
//             if (dateAtVideoPositionZero === null || dateAtVideoPositionZero === undefined) {
//                 dateAtVideoPositionZero = match.TrainingDate;
//             }
//             ts2 = new Date(dateAtVideoPositionZero.getTime() + vp * 1000);
//         }

//         var bs = "";
//         var be = "";
//         coneno = 0;
//         if ((et === "S" || et === "A") && code.length >= 11) {
//             var accode = code.substring(6, 8);
//             var atc = fetchAttackComboByCode(accode);

//             var xs = [83, 83, 50, 17, 17, 50, 17, 50, 83];
//             var yss = [210, 210, 210, 210, 210, 210, 210, 210, 210];
//             var ysa = [183, 100, 100, 100, 183, 183, 150, 150, 150];
//             var xe = [17, 17, 50, 83, 83, 50, 83, 50, 17];
//             var ye = [17, 83, 83, 83, 17, 17, 50, 50, 50];

//             var startzone = parseInt(code.substring(9, 10)) - 1;
//             var endzone = parseInt(code.substring(10, 11)) - 1;
//             if (startzone >= 0 && endzone >= 0) {
//                 var subendzone = code.length > 11 ? code.substring(11, 12) : "";
//                 // srand((int)time(NULL));
//                 var rxs = 0; //(rand() % 20) - 10;
//                 var rys = 0; //rand() % 5;

//                 const min = -4;
//                 const max = 4;
//                 var rxe = Math.random() * (max - min); //0; //(rand() % 10) - 5;
//                 var rye = Math.random() * (max - min); //(rand() % 10) - 5;

//                 var xendx = parseInt(xe[endzone]);
//                 var xendy = parseInt(ye[endzone]);
//                 if (subendzone === "A") {
//                     match.isZone = true;
//                     xendx -= 8;
//                     xendy -= 8;
//                 }
//                 else if (subendzone === "B") {
//                     match.isZone = true;
//                     xendx -= 8;
//                     xendy += 8;
//                 }
//                 else if (subendzone === "C") {
//                     match.isZone = true;
//                     xendx += 8;
//                     xendy += 8;
//                 }
//                 else if (subendzone === "D") {
//                     match.isZone = true;
//                     xendx += 8;
//                     xendy -= 8;
//                 }
//                 else if (subendzone === "~") {
//                     coneno = endzone + 1;
//                     rxe = 0; //(rand() % 20) - 10;
//                     rye = 0; //(rand() % 20) - 10;
//                 }

//                 if (et === "S") {
//                     bs = (xs[startzone] + rxs).toString() + "," + yss[startzone].toString();
//                 }
//                 else {
//                     if (atc != null) {
//                         var apt = atc.hittingPoint;
//                         if (apt.x === undefined && apt.y === undefined) {
//                             bs = (xs[startzone] + rxs).toString() + "," + ysa[startzone].toString();
//                         }
//                         else {
//                             bs = apt.x.toString() + "," + (100 + (50 - apt.y) * 2).toString();
//                         }
//                     }
//                     else {
//                         bs = (xs[startzone] + rxs).toString() + "," + (ysa[startzone] + rys).toString();
//                     }
//                 }
//                 be = (xendx + rxe).toString() + "," + (xendy + rye).toString();
//                 var endPoint = { x: xendx, y: xendy };
//             }
//         }
//         net = ets.indexOf(et);
//         if (net == kSkillSet - 1) {
//             net = kSkillSettersCall - 1;
//         }
//         if (net != -1) {
//             var neg = egs.indexOf(eg)
//             if (neg >= 0) {
//                 var ac = "";
//                 net += 1;
//                 var gr = neg;
//                 var err = 0;
//                 var netOK = true;
//                 var breakPoint = 0;
//                 switch (net) {
//                     case kSkillServe:
//                         {
//                             if (homescore == 6 && awayscore == 3) {
//                                 //                                NSLog(@"");
//                             }
//                             if (se === "H") {
//                                 subevent = kServeH;
//                             }
//                             else if (se === "M") {
//                                 subevent = kServeM;
//                             }
//                             else if (se === "Q") {
//                                 subevent = kServeQ;
//                             }
//                             else {
//                                 subevent = kServeO;
//                             }

//                             if (eg === "=") gr = 0;
//                             else if (eg === "/") gr = 5;
//                             else if (eg === "!") gr = 2;
//                             else if (eg === "-") gr = 1;
//                             else if (eg === "+") gr = 4;
//                             else if (eg === "#") {
//                                 gr = 3;
//                                 breakPoint = 1;
//                             }
//                             else gr = 1;
//                         }
//                         break;
//                     case kSkillPass:
//                         {
//                             if (se === "H") {
//                                 subevent = kPassH;
//                             }
//                             else if (se === "M") {
//                                 subevent = kPassM;
//                             }
//                             else if (se === "Q") {
//                                 subevent = kPassQ;
//                             }
//                             else {
//                                 subevent = kPassO;
//                             }
//                             passEvent = code;
//                             if (eg === "=") gr = 0;
//                             else if (eg === "/") { gr = 1; err = 1; }
//                             else if (eg === "-") gr = 1;
//                             else if (eg === "!") gr = 2;
//                             else if (eg === "+") { gr = 3; err = 1; }
//                             else if (eg === "#") gr = 3;
//                             else gr = 1;
//                         }
//                         break;
//                     case kSkillSet:
//                         {
//                             if (eg === "=") gr = 0;
//                             else if (eg === "-") gr = 1;
//                             else if (eg === "+") gr = 2;
//                             else if (eg === "#") gr = 3;
//                             else gr = 1;
//                         }
//                         break;
//                     case kSkillSettersCall:
//                         {
//                             if (code.length > 6) {
//                                 sc = code.substring(6, code.length);
//                             }
//                             if (eg === "=") gr = 0;
//                             else if (eg === "-") gr = 1;
//                             else if (eg === "+") gr = 2;
//                             else if (eg === "#") gr = 3;
//                             else gr = 1;
//                         }
//                         break;
//                     case kSkillSpike:
//                         {
//                             if (code.length > 6) {
//                                 ac = code.substring(6, 8);
//                             }
//                             if (se === "H") {
//                                 subevent = kSpikeH;
//                             }
//                             else if (se === "M") {
//                                 subevent = kSpikeM;
//                             }
//                             else if (se === "Q") {
//                                 subevent = kSpikeQ;
//                             }
//                             else if (se === "T") {
//                                 subevent = kSpikeT;
//                             }
//                             else if (se === "U") {
//                                 subevent = kSpikeU;
//                             }
//                             else if (se === "F") {
//                                 subevent = kSpikeF;
//                             }
//                             else {
//                                 subevent = kSpikeO;
//                             }

//                             if (eg === "=") gr = 0;
//                             else if (eg === "/") { gr = 0; err = 2; }
//                             else if (eg === "-") gr = 1;
//                             else if (eg === "!") { gr = 1; err = 2; }
//                             else if (eg === "+") gr = 2;
//                             else if (eg === "#") {
//                                 gr = 3;
//                                 if ((homePlayer && homeServing) ||
//                                     (!homePlayer && !homeServing)) {
//                                     breakPoint = 1;
//                                 }
//                             }
//                             else gr = 1;
//                         }
//                         break;
//                     case kSkillBlock:
//                         {
//                             if (eg === "=") gr = 0;
//                             else if (eg === "/") { gr = 0; err = 1; }
//                             else if (eg === "-") { gr = 1; err = 1; }
//                             else if (eg === "+") gr = 1;
//                             else if (eg === "#") {
//                                 gr = 2;
//                                 if ((homePlayer && homeServing) ||
//                                     (!homePlayer && !homeServing)) {
//                                     breakPoint = 1;
//                                 }
//                                 if (code.length > 12) {
//                                     var bt = code.substring(12, 13);
//                                     if (bt === "A")  //assist
//                                     {
//                                         gr = 3;
//                                     }
//                                     else if (bt === "T") //attempt
//                                     {
//                                     }
//                                 }
//                             }

//                             else gr = 1;
//                         }
//                         break;
//                     case kSkillDefense:
//                         {
//                             if (eg === "=") gr = 0;
//                             else if (eg === "/") { gr = 0; err = 1; }//over
//                             else if (eg === "-") { gr = 0; err = 2; }//poor
//                             else if (eg === "#") gr = 1;
//                             else gr = 1;
//                         }
//                         break;
//                     case kSkillFreeball:
//                         {
//                             if (eg === "=") gr = 0;
//                             else if (eg === "/") gr = 2; //no attack
//                             else if (eg === "-") gr = 2; //poor
//                             else if (eg === "+") gr = 2; //poor
//                             else if (eg === "#") gr = 1;
//                             else gr = 1;
//                         }
//                         break;
//                     default:
//                         {
//                             netOK = false;
//                         }
//                         break;
//                 }
//                 if (netOK) {
//                     eventCreated = true;
//                     var ev = null;
//                     if (homePlayer) {
//                         ev = createEvent(index, pl, g, ts2, net, subevent, breakPoint, gr, err, bs, be, homescore, awayscore, homerow, ac, sc, null, homeSetter, s, vp);
//                     }
//                     else {
//                         ev = createEvent(index, pl, g, ts2, net, subevent, breakPoint, gr, err, bs, be, homescore, awayscore, awayrow, ac, sc, null, awaySetter, s, vp);
//                     }
//                     if (net == kSkillSpike) {
//                         ev.UserDefined01 = passEvent;
//                         if (code.length >= 9) {
//                             var sz = code.substring(9, 10);
//                             ev.startZone = sz;
//                             ev.endZone = coneno.toString();
//                         }
//                         sc = "";
//                     }
//                     if (net == kSkillSpike || net == kSkillServe) {
//                         passEvent = "";
//                     }
//                     ev.EventId = pad(index * 10, 4);
//                     index++;
//                 }
//             }
//         }
//         else {
//             //                                NSLog(@"ETS = %@", ets);
//         }
//     }

//     if ((sn == 0 || isNaN(sn)) && !eventCreated) {
//         if (code.substring(1, 2) === "p") {
//             var sscores = code.substring(2, code.length);
//             var sss = sscores.split(":");
//             if (sss.length == 2) {
//                 homescore = parseInt(sss[0]);
//                 awayscore = parseInt(sss[1]);
//                 g.AwayScore = awayscore;
//                 g.HomeScore = homescore;
//                 scores = homescore.toString() + "-" + awayscore.toString();
//                 shouldUpdate = true;
//             }
//         }
//         else if (code.substring(1, 2) === "c") {
//             if (code.length < 7) {

//             }
//             else {
//                 var outpl = parseInt(code.substring(2, 4));
//                 var inpl = parseInt(code.substring(5, 7));
//                 vp = 0;
//                 if (sm.length > 12) {
//                     var svp = sm[12];
//                     if (svp.length > 0) {
//                         vp = parseInt(svp);
//                         if (vp > lastvp + (60 * 10))    // if vp is more than 10 minutes different then something wrong
//                         {
//                             vp = lastvp;
//                         }
//                         lastvp = vp;
//                     }
//                 }
//                 var ts2;
//                 if (tt.length > 0) {
//                     ts2 = new Date(matchdate + " " + tt.replace('.', ':'))
//                     if (dateAtVideoPositionZero == null) {
//                         dateAtVideoPositionZero = ts2;
//                     }
//                 }
//                 if (vp != 0) {
//                     if (videoposoffset == 0) {
//                         videoposoffset = vp;
//                         dateAtVideoPositionZero = new Date(ts2.toTimeString() - vp * 1000);
//                     }
//                     if (dateAtVideoPositionZero == null || dateAtVideoPositionZero === undefined) {
//                         dateAtVideoPositionZero = match.TrainingDate;
//                     }
//                     ts2 = new Date(dateAtVideoPositionZero.getTime() + vp * 1000);
//                 }

//                 if (code.substring(0, 1) === "*")    // home
//                 {
//                     var ipl = fetchPlayerInMatch(match.players, inpl);
//                     var opl = fetchPlayerInMatch(match.players, outpl);
//                     if (ipl !== null && opl !== null)
//                     {
//                         createEvent(index, opl, g, ts2, kSubstitution, 0, 0, 0, 0, "", "", homescore, awayscore, homerow, null, null, ipl.Guid, homeSetter, s, vp);
//                         index++;
//                     }
//                 }
//                 else if (code.substring(0, 1) === "a")    // away
//                 {
//                     var ipl = fetchPlayerInMatch(match.oppositionPlayers, inpl);
//                     var opl = fetchPlayerInMatch(match.oppositionPlayers, outpl);
//                     if (ipl !== null && opl !== null)
//                     {
//                         createEvent(index, opl, g, ts2, kSubstitution, 0, 0, 0, 0, "", "", homescore, awayscore, awayrow, null, null, ipl.Guid, awaySetter, s, vp);
//                         index++;
//                     }
//                 }
//             }
//         }
//         else if (code.length > 6 && code.substring(0, 7) === "**Drill") {
//             match.isTraining = true;
//             isPractice = true;
//             var lastg = match.drills[currentGame - 1];
//             lastg.IsLocked = true;
//             currentGame++;
//         }
//         else if ((code.substring(0, 2) === "**") && (code.substring(3, 6) === "set")) {
//             homescore = 0;
//             awayscore = 0;
//             var ssno = parseInt(code.substring(2, 3));
//             var lastg = match.drills[ssno - 1];
//             lastg.IsLocked = true;
//             currentGame = parseInt(sm[8]);
//         }
//         else if (code.substring(1, 2) === "z") {
//             var r = 0;
//             if (code.substring(0, 1) === "*")    // home setter pos
//             {
//                 r = parseInt(code.substring(2, 3));
//                 homerow = parseInt(rows[r]);
//                 match.homerow = homerow;
//                 var xx = parseInt(sm[9]) + 13;
//                 homeSetter = parseInt(sm[xx]);
//                 g.PrimarySetter = fetchPlayerInMatch(match.players, homeSetter);
//                 if (g.PrimarySetter.Positions.filter(obj => obj === 5).length === 0) {
//                     g.PrimarySetter.Positions.push(5)
//                 }
//             }
//             else if (code.substring(0, 1) === "a")    // home
//             {
//                 // away setter
//                 r = parseInt(code.substring(2, 3));
//                 awayrow = parseInt(rows[r]);
//                 match.awayrow = awayrow;
//                 var xx = parseInt(sm[10]) + 19;
//                 awaySetter = parseInt(sm[xx]);
//                 g.oppPrimarySetter = fetchPlayerInMatch(match.oppositionPlayers, awaySetter);
//                 if (g.oppPrimarySetter.Positions.filter(obj => obj === 5).length === 0) {
//                     g.oppPrimarySetter.Positions.push(5)
//                 }
//             }
//         }
//     }

//     if (match.videoStartTime == null && dateAtVideoPositionZero != null) {
//         match.videoStartTime = dateAtVideoPositionZero;
//     }
//     return shouldUpdate;

// }

function processScoutLine(s) {
  var shouldUpdate = false;
  var sm = s.split(";");
  if (sm.length < 9) {
    return shouldUpdate;
  }
  var coneno = 0;
  var thisgame = currentGame;
  if (isPractice == false) {
    var stg = sm[8];
    if (stg.length > 0) {
      thisgame = parseInt(stg);
    }
  }
  var g = match.drills[thisgame - 1];
  if (g === undefined || g === null) {
    return false;
  }

  currentGame = thisgame;
  var code = sm[0];
  var isHome = code.substring(0, 1) === "*";
  var tm = isHome ? match.Team : match.Opposition;
  var currentHomeLineup = [];
  var currentAwayLineup = [];
  var currentRotation = "";
  var pos = 1;
  homelineup = [];
  currentHomeLineup = [];
  awaylineup = [];
  currentAwayLineup = [];
  var cc1 = code.substring(0, 2);
  var cc2 = code.substring(4, 8);
  if (code.length == 8 && cc1 === "*P" && cc2 === ">LUp") {
    // DV lineup payload is in the final 12 fields:
    // first 6 = team A, last 6 = team B.
    // Filter blank tokens (trailing semicolons produce an empty last token).
    var smFiltered = sm.filter(function (t) {
      return t.trim() !== "";
    });
    var lineupStartIndex = Math.max(smFiltered.length - 12, 0);
    for (var nr = 0; nr < 6; nr++) {
      var nh = parseInt(smFiltered[lineupStartIndex + nr]);

      var pl = fetchPlayerInMatch(match.players, nh);
      if (pl != null) {
        currentHomeLineup.push(pl);
        if (homelineup.filter((obj) => obj.Guid === pl.Guid).length === 0) {
          homelineup.push(pl);
        }
      }

      var ah = parseInt(smFiltered[lineupStartIndex + 6 + nr]);
      pl = fetchPlayerInMatch(match.oppositionPlayers, ah);
      if (pl != null) {
        currentAwayLineup.push(pl);
        if (awaylineup.filter((obj) => obj.Guid === pl.Guid).length === 0) {
          awaylineup.push(pl);
        }
      }
    }

    for (var np = 0; np < homelibs.length; np++) {
      var pl = homelibs[np];
      if (homelineup.filter((obj) => obj.Guid === pl.Guid).length === 0) {
        homelineup.push(pl);
      }
    }
    currentRotation = "";
    pos = 1;
    for (var np = 0; np < homelineup.length; np++) {
      var pl = homelineup[np];
      if (currentRotation.length > 0) {
        currentRotation += ",";
      }
      currentRotation += pl.Guid;
      pos++;
    }
    g.StartingLineup = currentRotation;

    for (var np = 0; np < awaylibs.length; np++) {
      var pl = awaylibs[np];
      if (awaylineup.filter((obj) => obj.Guid === pl.Guid).length === 0) {
        awaylineup.push(pl);
      }
    }
    var currentOppRotation = "";
    pos = 1;
    for (var np = 0; np < awaylineup.length; np++) {
      var pl = awaylineup[np];
      if (currentOppRotation.length > 0) {
        currentOppRotation += ",";
      }
      currentOppRotation += pl.Guid;
      pos++;
    }
    g.OppositionStartingLineup = currentOppRotation;

    // Also expose the on-court lineup (in court-position order, 1..6) directly
    // on the team objects. `currentHomeLineup`/`currentAwayLineup` above are
    // already ordered by position (nr 0..5 mirrors the writer's position 1..6
    // tail). DVMatchCoding reads `team.currentLineup` as its fallback source
    // for the starting lineup when a set has no coded events yet to derive it
    // from (e.g. a brand-new match saved right after lineups are entered, but
    // before the first rally) — without this, that lineup was silently lost
    // on the next "Continue coding" reparse.
    match.teamA.currentLineup = currentHomeLineup.map((p, i) => ({
      ...p,
      position: String(i + 1),
      currentPosition: String(i + 1),
    }));
    match.teamB.currentLineup = currentAwayLineup.map((p, i) => ({
      ...p,
      position: String(i + 1),
      currentPosition: String(i + 1),
    }));
  }

  if (code.length < 3) {
    return shouldUpdate;
  }

  var eventCreated = false;
  var vp = 0;
  var tt = sm[7];
  var sn = parseInt(code.substring(1, 3));
  if (code.length >= 6 /* && tt != nil && tt.length > 0 */) {
    var pls = isHome ? match.players : match.oppositionPlayers;
    var pl = fetchPlayerInMatch(pls, sn);
    var net = 0;
    var neg = 0;
    var et = code.substring(3, 4);
    var se = code.substring(4, 5);
    var eg = code.substring(5, 6);
    var homePlayer = isHome;
    if (et === "S") {
      if (homePlayer) {
        homeServing = true;
      } else {
        homeServing = false;
      }
    } else if (et === "R") {
      if (homePlayer) {
        homeServing = false;
      } else {
        homeServing = true;
      }
    }
    if (tt.length == 0) {
      tt = lastTime;
    } else {
      lastTime = tt;
    }

    vp = 0;
    if (sm.length > 12) {
      var xnet = ets.indexOf(et);
      if (xnet != -1) {
        var svp = sm[12];
        if (svp.length > 0) {
          // parseFloat (not parseInt): VSM/VIS-converted matches write this
          // field as decimal seconds (sub-second precision from the source
          // video's millisecond timestamps) — truncating it here would
          // introduce up to ~1s of jitter per event between video and events.
          vp = parseFloat(svp);
          // // for occasions when match was coded from segmented videos
          // if (vp < lastvp && ((lastvp - (vp + keyvp)) > 1000)) {
          //     keyvp = lastvp;
          // }
          // vp += keyvp;
          // lastvp = vp;
        }
      }
    }
    var ts2 = null;
    if (tt.length > 0) {
      var ttt = matchdate + " " + tt.split(".").join(":");
      ts2 = new Date(moment(ttt, matchDateFormat + " HH:mm:ss"));
      // ts2 = tryParseDateFromString(ttt, "mdy");
      // if (ts2 === undefined) {
      //   ts2 = tryParseDateFromString(ttt, "ymd");
      // }
      // if (ts2 === undefined) {
      //   ts2 = tryParseDateFromString(ttt, "dmy");
      // }
      if (
        dateAtVideoPositionZero === null ||
        dateAtVideoPositionZero === undefined
      ) {
        dateAtVideoPositionZero = ts2;
      }
    }
    if (vp != 0) {
      if (videoposoffset === 0) {
        videoposoffset = vp;
        if (ts2 !== null && ts2 !== undefined) {
          dateAtVideoPositionZero = new Date(ts2.getTime() - vp * 1000);
        }
      }
      if (
        dateAtVideoPositionZero === null ||
        dateAtVideoPositionZero === undefined
      ) {
        dateAtVideoPositionZero = match.TrainingDate;
      }
      ts2 = new Date(dateAtVideoPositionZero.getTime() + vp * 1000);
    }

    var bs = "";
    var be = "";
    coneno = 0;
    if ((et === "S" || et === "A") && code.length >= 11) {
      var accode = code.substring(6, 8);
      var atc = fetchAttackComboByCode(accode);

      var xs = [83, 83, 50, 17, 17, 50, 17, 50, 83];
      var yss = [210, 210, 210, 210, 210, 210, 210, 210, 210];
      // Zones 2/3/4 (front row) must land INSIDE zoneFromString's bottommidpts
      // rectangle for those zones (center y=116.67, half-height 16.665, i.e.
      // valid range ~100.01-133.33) — 100 missed it by a hair, so any match
      // with no [3ATTACKCOMBINATION] table (every VIS/VSM import, every
      // DVMatchCoding-coded match) silently lost ALL front-row attacks from
      // Hitting Chart / Attack Zones (startZoneForEvent's fallback returned 0).
      var ysa = [183, 110, 110, 110, 183, 183, 150, 150, 150];
      var xe = [17, 17, 50, 83, 83, 50, 83, 50, 17];
      var ye = [17, 83, 83, 83, 17, 17, 50, 50, 50];

      var startzone = parseInt(code.substring(9, 10)) - 1;
      var endzone = parseInt(code.substring(10, 11)) - 1;
      if (startzone >= 0 && endzone >= 0) {
        var subendzone = code.length > 11 ? code.substring(11, 12) : "";
        // srand((int)time(NULL));
        var rxs = 0; //(rand() % 20) - 10;
        var rys = 0; //rand() % 5;

        const min = -4;
        const max = 4;
        var rxe = Math.random() * (max - min); //0; //(rand() % 10) - 5;
        var rye = Math.random() * (max - min); //(rand() % 10) - 5;

        var xendx = parseInt(xe[endzone]);
        var xendy = parseInt(ye[endzone]);
        if (subendzone === "A") {
          match.isZone = true;
          xendx -= 8;
          xendy -= 8;
        } else if (subendzone === "B") {
          match.isZone = true;
          xendx -= 8;
          xendy += 8;
        } else if (subendzone === "C") {
          match.isZone = true;
          xendx += 8;
          xendy += 8;
        } else if (subendzone === "D") {
          match.isZone = true;
          xendx += 8;
          xendy -= 8;
        } else if (subendzone === "~") {
          coneno = endzone + 1;
          rxe = 0; //(rand() % 20) - 10;
          rye = 0; //(rand() % 20) - 10;
        }

        if (et === "S") {
          bs =
            (xs[startzone] + rxs).toString() + "," + yss[startzone].toString();
        } else {
          // atc.hittingPoint is null when the file's own attack-combo
          // definition has no explicit coords AND the code isn't one of the
          // defaults in DefaultAttackCombos.js (getHittingPoint returns null
          // in that case) — fall back to the zone-based default instead of
          // crashing on apt.x.
          if (atc != null && atc.hittingPoint != null) {
            var apt = atc.hittingPoint;
            if (apt.x === undefined && apt.y === undefined) {
              bs =
                (xs[startzone] + rxs).toString() +
                "," +
                ysa[startzone].toString();
            } else {
              bs = apt.x.toString() + "," + (100 + (50 - apt.y) * 2).toString();
            }
          } else {
            bs =
              (xs[startzone] + rxs).toString() +
              "," +
              (ysa[startzone] + rys).toString();
          }
        }
        be = (xendx + rxe).toString() + "," + (xendy + rye).toString();
        var endPoint = { x: xendx, y: xendy };
      }
    }
    net = ets.indexOf(et);
    if (net == kSkillSet - 1) {
      net = kSkillSettersCall - 1;
    }
    if (et === "P") {
      // Manual point (the "Point" buttons) — DVWWriter emits a player-less
      // `*00P~<eval>` code. DataVolley has no "P" skill, so this branch is
      // purely additive and never fires for a real imported file. Recreate the
      // event (no Player) and tag its team via homePlayer so DVMatchCoding's
      // resume side-out replay counts the rally / rotation it caused.
      var pNeg = egs.indexOf(eg);
      var pGrade = pNeg >= 0 ? pNeg : 6;
      eventCreated = true;
      var pEv = createEvent(
        index,
        pl,
        g,
        ts2,
        kSkillManualPoint,
        0,
        0,
        pGrade,
        0,
        "",
        "",
        homescore,
        awayscore,
        isHome ? homerow : awayrow,
        null,
        null,
        null,
        isHome ? homeSetter : awaySetter,
        s,
        vp,
      );
      if (pEv) pEv.homePlayer = isHome;
      index++;
    }
    if (net != -1) {
      var neg = egs.indexOf(eg);
      if (neg >= 0) {
        var ac = "";
        net += 1;
        var gr = neg;
        var err = 0;
        var netOK = true;
        var breakPoint = 0;
        switch (net) {
          case kSkillServe:
            {
              if (homescore == 6 && awayscore == 3) {
                //                                NSLog("");
              }
              if (se === "H") {
                subevent = kServeH;
              } else if (se === "M") {
                subevent = kServeM;
              } else if (se === "Q") {
                subevent = kServeQ;
              } else {
                subevent = kServeO;
              }

              if (eg === "=") gr = 0;
              else if (eg === "/") gr = 5;
              else if (eg === "!") gr = 2;
              else if (eg === "-") gr = 1;
              else if (eg === "+") gr = 4;
              else if (eg === "#") {
                gr = 3;
                breakPoint = 1;
              } else gr = 1;
            }
            break;
          case kSkillPass:
            {
              if (se === "H") {
                subevent = kPassH;
              } else if (se === "M") {
                subevent = kPassM;
              } else if (se === "Q") {
                subevent = kPassQ;
              } else {
                subevent = kPassO;
              }
              passEvent = code;
              if (eg === "=") gr = 0;
              else if (eg === "/") {
                gr = 1;
                err = 1;
              } else if (eg === "-") gr = 1;
              else if (eg === "!") gr = 2;
              else if (eg === "+") {
                gr = 3;
                err = 1;
              } else if (eg === "#") gr = 3;
              else gr = 1;
            }
            break;
          case kSkillSet:
            {
              if (eg === "=") gr = 0;
              else if (eg === "-") gr = 1;
              else if (eg === "+") gr = 2;
              else if (eg === "#") gr = 3;
              else gr = 1;
            }
            break;
          case kSkillSettersCall:
            {
              if (code.length > 6) {
                sc = code.substring(6, code.length);
              }
              if (eg === "=") gr = 0;
              else if (eg === "-") gr = 1;
              else if (eg === "+") gr = 2;
              else if (eg === "#") gr = 3;
              else gr = 1;
            }
            break;
          case kSkillSpike:
            {
              if (code.length > 6) {
                ac = code.substring(6, 8);
              }
              if (se === "H") {
                subevent = kSpikeH;
              } else if (se === "M") {
                subevent = kSpikeM;
              } else if (se === "Q") {
                subevent = kSpikeQ;
              } else if (se === "T") {
                subevent = kSpikeT;
              } else if (se === "U") {
                subevent = kSpikeU;
              } else if (se === "F") {
                subevent = kSpikeF;
              } else {
                subevent = kSpikeO;
              }

              if (eg === "=") gr = 0;
              else if (eg === "/") {
                gr = 0;
                err = 2;
              } else if (eg === "-") gr = 1;
              else if (eg === "!") {
                gr = 1;
                err = 2;
              } else if (eg === "+") gr = 2;
              else if (eg === "#") {
                gr = 3;
                if (
                  (homePlayer && homeServing) ||
                  (!homePlayer && !homeServing)
                ) {
                  breakPoint = 1;
                }
              } else gr = 1;
            }
            break;
          case kSkillBlock:
            {
              if (eg === "=") gr = 0;
              else if (eg === "/") {
                gr = 0;
                err = 1;
              } else if (eg === "-") {
                gr = 1;
                err = 1;
              } else if (eg === "+") gr = 1;
              else if (eg === "#") {
                gr = 2;
                if (
                  (homePlayer && homeServing) ||
                  (!homePlayer && !homeServing)
                ) {
                  breakPoint = 1;
                }
                if (code.length > 12) {
                  var bt = code.substring(12, 13);
                  if (bt === "A") {
                    //assist
                    gr = 3;
                  } else if (bt === "T") {
                    //attempt
                  }
                }
              } else gr = 1;
            }
            break;
          case kSkillDefense:
            {
              if (eg === "=") gr = 0;
              else if (eg === "/") {
                gr = 0;
                err = 1;
              } //over
              else if (eg === "-") {
                gr = 0;
                err = 2;
              } //poor
              else if (eg === "#") gr = 1;
              else gr = 1;
            }
            break;
          case kSkillFreeball:
            {
              if (eg === "=") gr = 0;
              else if (eg === "/")
                gr = 2; //no attack
              else if (eg === "-")
                gr = 2; //poor
              else if (eg === "+")
                gr = 2; //poor
              else if (eg === "#") gr = 1;
              else gr = 1;
            }
            break;
          default:
            {
              netOK = false;
            }
            break;
        }
        if (netOK) {
          eventCreated = true;
          var ev = null;
          if (homePlayer) {
            ev = createEvent(
              index,
              pl,
              g,
              ts2,
              net,
              subevent,
              breakPoint,
              gr,
              err,
              bs,
              be,
              homescore,
              awayscore,
              homerow,
              ac,
              sc,
              null,
              homeSetter,
              s,
              vp,
            );
          } else {
            ev = createEvent(
              index,
              pl,
              g,
              ts2,
              net,
              subevent,
              breakPoint,
              gr,
              err,
              bs,
              be,
              homescore,
              awayscore,
              awayrow,
              ac,
              sc,
              null,
              awaySetter,
              s,
              vp,
            );
          }
          if (net == kSkillSpike) {
            ev.UserDefined01 = passEvent;
            ev.isSideOut = isSideOut;
            passEvent = "";
            isSideOut = false;
            if (code.length >= 9) {
              var sz = code.substring(9, 10);
              ev.startZone = sz;
              ev.endZone = coneno.toString();
            }
            sc = "";
          }
          if (net == kSkillServe) {
            passEvent = "";
            isSideOut = true;
          }
          ev.EventId = pad(index * 10, 4);
          index++;
        }
      }
    } else {
      //                                NSLog("ETS = %", ets);
    }
  }

  if ((sn == 0 || isNaN(sn)) && !eventCreated) {
    if (code.substring(1, 2) === "p") {
      var sscores = code.substring(2, code.length);
      var sss = sscores.split(":");
      if (sss.length == 2) {
        homescore = parseInt(sss[0]);
        awayscore = parseInt(sss[1]);
        g.AwayScore = awayscore;
        g.HomeScore = homescore;
        scores = homescore.toString() + "-" + awayscore.toString();
        shouldUpdate = true;
      }
    } else if (code.substring(1, 2) === "c") {
      if (code.length < 7) {
      } else {
        var outpl = parseInt(code.substring(2, 4));
        var inpl = parseInt(code.substring(5, 7));
        vp = 0;
        if (sm.length > 12) {
          var svp = sm[12];
          if (svp.length > 0) {
            // parseFloat: see comment on the equivalent event-code parsing above.
            vp = parseFloat(svp);
            if (vp > lastvp + 60 * 10) {
              // if vp is more than 10 minutes different then something wrong
              vp = lastvp;
            }
            lastvp = vp;
          }
        }
        var ts2;
        if (tt.length > 0) {
          var ttt = matchdate + " " + tt.split(".").join(":");
          ts2 = new Date(moment(ttt, matchDateFormat + " HH:mm:ss"));
          // ts2 = new Date(matchdate + " " + tt.replace(".", ":"));
          if (dateAtVideoPositionZero == null) {
            dateAtVideoPositionZero = ts2;
          }
        }
        if (vp != 0) {
          if (videoposoffset == 0) {
            videoposoffset = vp;
            dateAtVideoPositionZero = new Date(ts2.toTimeString() - vp * 1000);
          }
          if (
            dateAtVideoPositionZero == null ||
            dateAtVideoPositionZero === undefined
          ) {
            dateAtVideoPositionZero = match.TrainingDate;
          }
          ts2 = new Date(dateAtVideoPositionZero.getTime() + vp * 1000);
        }

        if (code.substring(0, 1) === "*") {
          // home
          var ipl = fetchPlayerInMatch(match.players, inpl);
          var opl = fetchPlayerInMatch(match.players, outpl);
          if (ipl !== null && opl !== null) {
            createEvent(
              index,
              opl,
              g,
              ts2,
              kSubstitution,
              0,
              0,
              0,
              0,
              "",
              "",
              homescore,
              awayscore,
              homerow,
              null,
              null,
              ipl.Guid,
              homeSetter,
              s,
              vp,
            );
            index++;
          }
        } else if (code.substring(0, 1) === "a") {
          // away
          var ipl = fetchPlayerInMatch(match.oppositionPlayers, inpl);
          var opl = fetchPlayerInMatch(match.oppositionPlayers, outpl);
          if (ipl !== null && opl !== null) {
            createEvent(
              index,
              opl,
              g,
              ts2,
              kSubstitution,
              0,
              0,
              0,
              0,
              "",
              "",
              homescore,
              awayscore,
              awayrow,
              null,
              null,
              ipl.Guid,
              awaySetter,
              s,
              vp,
            );
            index++;
          }
        }
      }
    } else if (code.length > 6 && code.substring(0, 7) === "**Drill") {
      match.isTraining = true;
      isPractice = true;
      var lastg = match.drills[currentGame - 1];
      lastg.IsLocked = true;
      currentGame++;
    } else if (
      code.substring(0, 2) === "**" &&
      code.substring(3, 6) === "set"
    ) {
      homescore = 0;
      awayscore = 0;
      var ssno = parseInt(code.substring(2, 3));
      var lastg = match.drills[ssno - 1];
      lastg.IsLocked = true;
      currentGame = parseInt(sm[8]);
    } else if (code.substring(1, 2) === "z") {
      var r = 0;
      if (code.substring(0, 1) === "*") {
        // home setter pos
        r = parseInt(code.substring(2, 3));
        homerow = parseInt(rows[r]);
        match.homerow = homerow;
        var xx = parseInt(sm[9]) + 13;
        if (sm[xx].length > 0) {
          homeSetter = parseInt(sm[xx]);
          g.PrimarySetter = fetchPlayerInMatch(match.players, homeSetter);
          if (
            g.PrimarySetter.Positions.filter((obj) => obj === 5).length === 0
          ) {
            if (g.PrimarySetter.Positions.length === 0) {
              g.PrimarySetter.Positions.push(5);
            }
          }
        } else {
          console.log(s);
        }
      } else if (code.substring(0, 1) === "a") {
        // home
        // away setter
        r = parseInt(code.substring(2, 3));
        awayrow = parseInt(rows[r]);
        match.awayrow = awayrow;
        var xx = parseInt(sm[10]) + 19;
        if (sm[xx].length > 0) {
          awaySetter = parseInt(sm[xx]);
          g.oppPrimarySetter = fetchPlayerInMatch(
            match.oppositionPlayers,
            awaySetter,
          );
          if (g.oppPrimarySetter) {
            if (!g.oppPrimarySetter.Positions) {
              if (g.oppPrimarySetter.Positions.length === 0) {
                g.oppPrimarySetter.Positions = [];
              }
            }
            if (
              g.oppPrimarySetter.Positions.filter((obj) => obj === 5).length ===
              0
            ) {
              g.oppPrimarySetter.Positions.push(5);
            }
          }
        }
      }
    }
  }

  if (match.videoStartTime == null && dateAtVideoPositionZero != null) {
    match.videoStartTime = dateAtVideoPositionZero;
  }
  return shouldUpdate;
}

function createEvent(
  eindex,
  pl,
  g,
  ts2,
  et,
  se,
  se2,
  grade,
  err,
  bs,
  be,
  xhomescore,
  xawayscore,
  row,
  ud,
  scall,
  subGuid,
  setter,
  dvs,
  vp,
) {
  var ev = {};
  ev.Player = pl;
  ev.Drill = g;
  ev.TimeStamp = ts2;
  ev.EventId = eindex.toString();
  ev.EventType = et;
  ev.SubEvent = se;
  ev.SubEvent2 = se2;
  ev.ErrorType = err;
  ev.VideoPosition = vp;
  if (grade == 0.5) {
    ev.EventGrade = 0;
    ev.ErrorType = 1;
  } else {
    ev.EventGrade = grade;
  }
  ev.TeamScore = xhomescore;
  ev.OppositionScore = xawayscore;
  ev.Row = row;
  ev.BallStartString = bs;
  ev.BallEndString = be;
  ev.attackCombo = ud;
  ev.settersCall = scall;
  ev.substitution = subGuid;
  ev.setter = setter;
  ev.dvString = dvs;
  // Only a serve carries a Power Play call per the spec.
  ev.powerPlayCode = et === kSkillServe ? extractPowerPlayCode(dvs) : null;
  // Anything past the fixed-position fields (character 16 onward) is a
  // generic custom code -- same content VolleyStation calls "custom".
  ev.customCode = extractCustomCode(dvs);

  ev.AdvanceCode1 = AdvanceCode(6, 8, ev);
  ev.AdvanceCode2 = AdvanceCode(8, 9, ev);
  ev.AdvanceCode3 = AdvanceCode(9, 10, ev);
  ev.AdvanceCode4 = AdvanceCode(10, 11, ev);
  ev.AdvanceCode5 = AdvanceCode(11, 12, ev);
  ev.ExtraCode1 = AdvanceCode(12, 13, ev);
  ev.ExtraCode2 = AdvanceCode(13, 14, ev);
  ev.ExtraCode3 = AdvanceCode(14, 15, ev);
  ev.DVGrade = AdvanceCode(5, 6, ev);

  var gr = 0;
  if (et === kSkillPass) {
    if (ev.DVGrade === "=") gr = 0;
    else if (ev.DVGrade === "/") gr = 0.5;
    else if (ev.DVGrade === "-") gr = 1;
    else if (ev.DVGrade === "!") gr = 2;
    else if (ev.DVGrade === "+") gr = 3;
    else if (ev.DVGrade === "#") gr = 3;
  }
  ev.passingGrade = gr;

  switch (ev.EventType) {
    case 1:
      ev.EventString = "Serve ";
      break;
    case 2:
      ev.EventString = "Pass ";
      break;
    case 3:
      ev.EventString = "Setter Calls ";
      break;
    case 4:
      ev.EventString = "Spike ";
      break;
    case 5:
      ev.EventString = "Block ";
      break;
    case 6:
      ev.EventString = "Dig ";
      break;
    case 7:
      ev.EventString = "Cover";
      break;
    case 20:
      ev.EventString = "Setter Calls ";
      break;
    case 250:
      ev.EventString = "Substitution ";
      break;
    default:
      break;
  }

  ev.NumberOfBlocks = "";
  if (ev.ExtraCode2.length > 0) {
    if (ev.ExtraCode2 === "~") {
      ev.NumberOfBlocks = "BU";
    } else {
      const n = Number.parseInt(ev.ExtraCode2);

      if (n >= 0 && n < 5) {
        var str = ["B0", "B1", "B2", "B3", "BS"];
        ev.NumberOfBlocks = str[n];
      }
    }
  }

  g.events.push(ev);
  match.events.push(ev);

  return ev;
}

function AdvanceCode(start, end, ev) {
  var tokens = ev.dvString.split(";");
  if (tokens.length == 0) {
    return "";
  }
  var s = tokens[0];
  if (s.length >= end) {
    return s.substring(start, end);
  }
  return "";
}

// "Power Play" extended code, carried on a SERVE event's own scout code —
// "HP" (Home called), "AP" (Away called), "HAP"/"AHP" (both teams called,
// letter order = which team called first). Both DataVolley/VolleyStation
// exports and our own writer append this right after the fixed-position
// zone/subzone/extra-code fields, so a plain end-of-string match (rather than
// a fixed index) is robust to codes with or without zone/subzone data.
function extractPowerPlayCode(line) {
  const code = String(line ?? "").split(";")[0] ?? "";
  const m = code.match(/(HAP|AHP|HP|AP)$/);
  return m ? m[1] : null;
}

// Character 16 onward (index 15+) of the scout code is free-form custom
// content -- same character range VolleyStation's "custom" field maps to.
function extractCustomCode(line) {
  const code = String(line ?? "").split(";")[0] ?? "";
  return code.length > 15 ? code.substring(15) : "";
}


function realTargetHitter(ac) {
  if (ac.targetHitter.length == 1 && ac.targetHitter !== "-") {
    return ac.targetHitter;
  }

  var startZone = ac.startZone;

  if (ac.ballType === "Q") {
    return "C";
  } else if (ac.ballType === "O" && startZone == 3) {
    return "S";
  }

  if (startZone == 2 || startZone == 1 || startZone == 9) {
    return "B";
  } else if (startZone == 4 || startZone == 5 || startZone == 7) {
    return "F";
  } else {
    if (ac.isBackcourt) {
      return "P";
    }
    // ac.hittingPoint can be null (unmatched/coordinate-less attack combo
    // code — see getAttackCombination) — default to "F" rather than crash.
    var pt = ac.hittingPoint;
    if (pt == null || pt.x < 50) {
      return "F";
    } else {
      return "B";
    }
  }
  return "";
}

export function parseLatestDVWStats(latest, m) {
  if (latest === null || latest.length <= 0) {
    return m;
  }

  for (var n = 0; n < latest.length; n++) {
    var ls = latest[n];
    var buffer = unzipBuffer(ls.contents);
    if (buffer !== null) {
      // console.log('buffer =======', buffer)
      match = m;
      processScoutLine(buffer);
    }
  }
  return match;
}

function getPlayerStatsItem(pl, gm) {
  if (pl.statsItems === undefined) {
    pl.statsItems = [];
  }
  for (var sn = 0; sn < pl.statsItems.length; sn++) {
    var si = pl.statsItems[sn];
    if (si.set !== null && si.GameNumber === gm.GameNumber) {
      return si;
    }
  }
  si = createStatsItem(pl, gm);
  pl.statsItems.push(si);
  return si;
}

// Propagates each set's Power Play calls from the serve event that carries
// the code to every event in that same rally (a new rally starts at the next
// serve) — the exporter re-tags every serve within the 3-rally window with
// the same code, so we don't need to count rallies ourselves, just carry the
// marker forward until the NEXT serve resets/clears it.
function markPowerPlayRallies(m) {
  if (!m || !m.drills) return;
  for (const game of m.drills) {
    if (!game.events) continue;
    let activeCode = null;
    for (const ev of game.events) {
      if (ev.EventType === kSkillServe) {
        activeCode = ev.powerPlayCode || null;
      }
      ev.powerPlay = activeCode;
      ev.powerPlayTeams = activeCode ? powerPlayTeamsForCode(activeCode) : [];
    }
  }
}

export function calculateDVWStats(m) {
  if (m == null || m.drills === undefined) {
    return null;
  }
  markPowerPlayRallies(m);
  // Drives conditional UI (e.g. the Power Play report tab only appears for
  // matches that actually used it).
  m.hasPowerPlays = m.drills.some((g) => (g.events ?? []).some((e) => e.powerPlay));
  //prepare sets
  for (var sn = 0; sn < m.drills.length; sn++) {
    var game = m.drills[sn];
    game.teamAStatsItems = [];
    var sia = createStatsItem(null, game);
    game.teamAStatsItems.push(sia);

    game.teamBStatsItems = [];
    var sib = createStatsItem(null, game);
    game.teamBStatsItems.push(sib);
  }

  //do team A
  for (var pn = 0; pn < m.teamA.players.length; pn++) {
    var pl = m.teamA.players[pn];
    if (pl.statsItems === undefined) {
      pl.statsItems = [];
      pl.statsItems.push(createStatsItem(pl, null));
    }
    for (var sn = 0; sn < m.drills.length; sn++) {
      var game = m.drills[sn];
      if (game.events == undefined) {
        continue;
      }
      var si = getPlayerStatsItem(pl, game);
      var siteam = createStatsItem(null, game);
      for (var en = 0; en < game.events.length; en++) {
        var ev = game.events[en];
        if (ev.Player === null) {
          continue;
        }
        if (ev.Player.Guid === pl.Guid) {
          si = doEvent(ev, si);
        }
        if (
          m.teamA.players.filter((obj) => obj.Guid === ev.Player.Guid).length >
          0
        ) {
          siteam = doEvent(ev, siteam);
        }
      }
      calculateAllStats(siteam);
      game.teamAStatsItems[0] = siteam;
      calculateAllStats(si);
    }
  }
  m.teamA.statsItems = [];
  var ssmatchteam = createStatsItem(null, null);
  m.teamA.statsItems.push(ssmatchteam);
  for (var pn = 0; pn < m.teamA.players.length; pn++) {
    pl = m.teamA.players[pn];
    var ssmatch = createStatsItem(pl, null);
    for (var sn = 1; sn < pl.statsItems.length; sn++) {
      var game = m.drills[sn - 1];
      game.teamAStatsItems.push(pl.statsItems[sn]);
      ssmatch = addStatsItem(pl.statsItems[sn], ssmatch);
      ssmatch.gamesPlayed++;
      ssmatchteam = addStatsItem(pl.statsItems[sn], ssmatchteam);
      ssmatchteam.gamesPlayed++;
    }
    calculateAllStats(ssmatch);
    pl.statsItems[0] = ssmatch;
    m.teamA.statsItems.push(ssmatch);
    calculateAllStats(ssmatchteam);
  }

  //do team B
  for (var pn = 0; pn < m.teamB.players.length; pn++) {
    var pl = m.teamB.players[pn];
    if (pl.statsItems === undefined) {
      pl.statsItems = [];
      pl.statsItems.push(createStatsItem(pl, null));
    }
    for (var sn = 0; sn < m.drills.length; sn++) {
      var game = m.drills[sn];
      if (game.events == undefined) {
        continue;
      }
      var si = getPlayerStatsItem(pl, game);
      var siteam = createStatsItem(null, game);
      for (var en = 0; en < game.events.length; en++) {
        var ev = game.events[en];
        if (ev.Player === null) {
          continue;
        }
        if (ev.Player.Guid === pl.Guid) {
          si = doEvent(ev, si);
        }
        if (
          m.teamB.players.filter((obj) => obj.Guid === ev.Player.Guid).length >
          0
        ) {
          siteam = doEvent(ev, siteam);
        }
      }
      calculateAllStats(siteam);
      game.teamBStatsItems[0] = siteam;
      calculateAllStats(si);
    }
  }
  m.teamB.statsItems = [];
  var ssmatchteam = createStatsItem(null, null);
  m.teamB.statsItems.push(ssmatchteam);
  for (var pn = 0; pn < m.teamB.players.length; pn++) {
    pl = m.teamB.players[pn];
    var ssmatch = createStatsItem(pl, null);
    for (var sn = 1; sn < pl.statsItems.length; sn++) {
      var game = m.drills[sn - 1];
      game.teamBStatsItems.push(pl.statsItems[sn]);
      ssmatch = addStatsItem(pl.statsItems[sn], ssmatch);
      ssmatch.gamesPlayed++;
      ssmatchteam = addStatsItem(pl.statsItems[sn], ssmatchteam);
      ssmatchteam.gamesPlayed++;
    }
    calculateAllStats(ssmatch);
    pl.statsItems[0] = ssmatch;
    m.teamB.statsItems.push(ssmatch);
    calculateAllStats(ssmatchteam);
  }

  for (var sn = 1; sn < pl.statsItems.length; sn++) {
    var game = m.drills[sn - 1];
  }

  return m;
}

export function eventString(e) {
  var s = "";
  switch (e.EventType) {
    case 1:
      s += "Serve ";
      break;
    case 2:
      s += "Pass ";
      break;
    case 3:
      s += "Setter Calls ";
      break;
    case 4:
      s += "Spike ";
      break;
    case 5:
      s += "Block ";
      break;
    case 6:
      s += "Dig ";
      break;
    case 7:
      s += "Cover";
      break;
    case 20:
      s += "Setter Calls ";
      break;
    case 250:
      s += "Substitution ";
      break;
    default:
      break;
  }
  const gr1 = ["Error", "1", "2", "Ace", "3", "Speed"];
  const gr1err = ["", "Net", "Out Long", "Out Side"];
  const gr2 = ["Error", "1", "2", "3"];
  const gr3 = ["Error", "", "Set Assist", ""];
  const gr4 = ["Error", "In Play", "In Play", "Kill"];
  const gr4err = ["", "Out", "Blocked", "Net", "Net Touch"];
  const gr5 = ["Error", "Control", "Solo", "Block Assist"];
  const gr6 = ["Error", "1", "2", "3"];
  const hr = ["", "Off-speed", "Dump", "Power", "Off-Block"];
  const sr = ["", "Jump", "Jump-Float", "Float", "Topspin"];

  const eerr = e.ErrorType;
  const eg = e.EventGrade;
  if (eg < 0) eg = 0;
  var sub = e.SubEvent;
  const sub2 = e.SubEvent2;
  const set = 0;
  if (sub >= 110) {
    const x = sub % 1000;
    set = x - 110;
    sub = (sub - x) / 1000;
  }

  switch (e.EventType) {
    case 1:
      s += gr1[eg];
      if (sub > 0) {
        s += " " + sr[sub];
      }
      if (eg == 0 && eerr > 0) {
        s += " (" + gr1err[eerr] + ")";
      }
      break;
    case 2:
      if (eg >= gr2.length) break;
      s += gr2[eg];
      break;
    case 3:
      s += gr3[eg];
      break;
    case 4: {
      {
        var numblocks = "";
        if (sub2 != 0) {
          numblocks = " " + (sub2 - 1).toString() + "B";
        }
        if (eg == 0) {
          {
            s += gr4[0];
            if (eerr > 0) {
              s += " (" + gr4err[eerr] + ")";
            }
            s += numblocks;
            break;
          }
        } else if (eg == 1 || eg == 2) {
          if (sub == 0) {
            s += gr4[2] + numblocks;
            break;
          } //if (sub != 3)
          else {
            if (sub < 0 || sub >= hr.length) {
              sub = 0;
            }
            s += gr4[2] + " " + hr[sub] + numblocks;
            break;
          }
        } else {
          if (sub > 0 && sub != 3 && sub < hr.length) {
            s += gr4[3] + " " + hr[sub] + numblocks;
            break;
          } else {
            s += gr4[3] + numblocks;
            break;
          }
        }
      }
    }
    case 5: {
      const n = eg;
      if (n > 3) {
        break;
      }
      if (eg == 3) {
        if (sub == 0) {
          n = 2;
        }
      }
      s += gr5[n];
      break;
    }
    case 6:
      if (eg < gr6.length) {
        s += gr6[eg];
        break;
      } else {
        break;
      }
    case kSkillSettersCall: {
      s += e.settersCall.substring(0, 2); // setters call
      break;
    }
    case 250: {
      break;
    }
  }
  return s;
}

export function DVEventString(e) {
  if (e.DVGrade === undefined) {
    // PSVB
  } else {
    var sc =
      e.settersCall != undefined && e.settersCall.length >= 2
        ? e.settersCall.substring(0, 2)
        : "";
    if (e.EventType == kSubstitution) {
      var sub = null;
      var substr = sub == null ? "" : "";
      return e.EventString;
    } else if (e.EventType == kSkillSpike) {
      const aitems = ["", "H", "M", "Q", "T", "U", "F", "O"];
      var sse = "";
      if (
        e.SubEvent !== undefined &&
        e.SubEvent < aitems.length &&
        e.SubEvent >= 0
      ) {
        sse = aitems[e.SubEvent];
      } else {
        sse = "?";
      }
      return (
        e.DVGrade +
        " " +
        e.EventString +
        " - " +
        e.attackCombo +
        " - " +
        sc +
        " - " +
        e.ExtraCode1 +
        " " +
        sse +
        " - " +
        e.NumberOfBlocks
      );
    } else if (e.EventType == kSkillSettersCall) {
      return e.DVGrade + " " + e.EventString + " - " + sc;
    } else {
      return e.DVGrade + " " + e.EventString;
    }
  }
}
